class SettingsUtil {
    getUserKey(userId) {
        return `spark-settings-${userId}`
    }

    getUserSettings(userId) {
        var item = localStorage.getItem(this.getUserKey(userId))
        return item ? JSON.parse(item) : {}
    }

    getSetting(userId, keyValue) {
        if (userId && keyValue) {
            return this.getUserSettings(userId)[keyValue]
        } else {
            console.log('attempting to get setting for ', userId, keyValue)
            return null;
        }
    }

    setSetting(userId, keyValue, value) {
        console.log("attempting to set setting for ", userId, keyValue)
        if (userId && keyValue) {
            var currSettings = this.getUserSettings(userId);
            var updatedSettings = Object.assign({}, currSettings, { [keyValue]: value })
            localStorage.setItem(this.getUserKey(userId), JSON.stringify(updatedSettings))
        }
    }
}

const settingsUtil = new SettingsUtil();
export default settingsUtil;